<template>
  <div class="container">
    <div class="userinfo-cnt">
				<h3>基本信息</h3>
				<div class="userinfo-avatar clearfix">
					<img :src="userInfo.headPic?userInfo.headPic:require('../../../assets/default_avatar.png')" />
					<div class="userinfo-avatar-r">
						<p class="userinfo-username">{{userInfo.kylinsoftUserId}}</p>
						<p>{{userInfo.nickName}}</p>
					</div>
					<span class="baseinfo-more" @click="showuserDialog">编辑</span>
				</div>
				<div class="clearfix"></div>
				<div class="baseinfo-title clearfix">
					<h3>当前积分</h3>
				</div>
				<div class="baseinfo-list-wrap">
					<div class="baseinfo-list" v-if="activityType==1">
						<div class="baseinfo-item">综合积分</div>
						<div class="baseinfo-num"><span>{{integralInfo.integralNum}}</span>分</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">适配积分</div>
						<div class="baseinfo-num"><span>{{integralInfo.adaIntegralNum}}</span>分</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">测试积分</div>
						<div class="baseinfo-num"><span>{{integralInfo.testIntegralNum}}</span>分</div>
					</div>
				</div>
				<div class="baseinfo-title clearfix">
					<h3>当前排名</h3>
				</div>
				<div class="baseinfo-list-wrap">
					<div class="baseinfo-list" v-if="activityType==1">
						<div class="baseinfo-item">综合排名</div>
						<div class="baseinfo-num"><span>{{integralInfo.rank}}</span>位</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">适配排名</div>
						<div class="baseinfo-num"><span>{{integralInfo.adaRank}}</span>位</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">测试排名</div>
						<div class="baseinfo-num"><span>{{integralInfo.testRank}}</span>位</div>
					</div>
				</div>
				<div class="baseinfo-title clearfix" v-if="activityType==1">
					<h3>获奖信息</h3>
					<span class="baseinfo-more" @click="showPrizeDialog">查看详细</span>
				</div>
				<div class="baseinfo-list-wrap" v-if="activityType==1">
					<div class="baseinfo-list">
						<div class="baseinfo-item">月度奖</div>
						<div class="baseinfo-num"><span>{{integralInfo.prizeMonthTime}}</span>次</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">季度奖</div>
						<div class="baseinfo-num"><span>{{integralInfo.priceQuarterTime}}</span>次</div>
					</div>
					<div class="baseinfo-list">
						<div class="baseinfo-item">年度奖</div>
						<div class="baseinfo-num"><span>{{integralInfo.priceYearTime}}</span>次</div>
					</div>
				</div>
				<div class="baseinfo-title clearfix">
					<h3>积分明细</h3>
					<span class="baseinfo-more" @click="showIntegralDialog">查看详细</span>
				</div>
				<table class="integral-table">
					<thead>
						<tr>
							<td style="width:20%">积分</td>
							<td style="width: 60%">描述</td>
							<td style="width:20%">日期</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in dataList" :key="item.id">
							<td class="colorred">+{{item.integralNum}}</td>
							<td>{{item.content}}</td>
							<td>{{item.addTimeStr}}</td>
						</tr>
					</tbody>
				</table>
				<ContentNo content="暂时没有积分明细" v-if="dataList.length<=0"/>
		</div>
		<el-dialog
		title="积分明细"
		:visible.sync="integralDialog"
		width="60%"
		:before-close="closeIntegralDialog">
			<div>
				<table class="integral-table">
					<thead>
						<tr>
							<td style="width:20%">积分</td>
							<td style="width: 60%">描述</td>
							<td style="width:20%">日期</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in dataList" :key="item.id">
							<td class="colorred">+{{item.integralNum}}</td>
							<td>{{item.content}}</td>
							<td>{{item.addTimeStr}}</td>
						</tr>
					</tbody>
				</table>
				<ContentNo content="暂时没有积分明细" v-if="dataList.length<=0"/>
				<div class="page-size" v-if="dataList.length>this.pageSize">
					<el-pagination
					background
					@current-change="handleCurrentChange"
					:page-size= this.pageSize
					layout="prev, pager, next"
					:total= this.total>
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<el-dialog
		title="获奖信息"
		:visible.sync="prizelDialog"
		width="60%"
		:before-close="closePrizeDialog">
			<div>
				<table class="integral-table">
					<thead>
						<tr>
							<td style="width:20%">日期</td>
							<td style="width:20%">积分</td>
							<td style="width:10%">排名</td>
							<td style="width:25%">奖项名称</td>
							<td style="width:25%">奖项说明</td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in dataList" :key="item.id">
							<td>{{item.prizeDate}}</td>
							<td class="colorred">+{{item.integralNum}}</td>
							<td>{{item.rank}}</td>
							<td>{{item.prizeName}}</td>
							<td>{{item.remark}}</td>
						</tr>
					</tbody>
				</table>
				<ContentNo content="暂时没有获奖信息" v-if="dataList.length<=0"/>
				<div class="page-size">
					<el-pagination
					background
					@current-change="handleCurrentChange"
					:page-size= this.pageSize
					layout="prev, pager, next"
					hide-on-single-page
					:total= this.total>
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<!--编辑基本信息-->
		<el-dialog
		:visible.sync="userDialog"
		width="40%"
		:before-close="closeUserDialog">
			<div class="user-dialog">
				<div class="dialog-avatar">
					<!-- <h6>个人信息</h6> -->
					<el-upload
					:show-file-list="false"
					:on-success="handleAvatarSuccess"
					:action="uploadUrl">
						<div class="avatar-cnt">
							<img :src="headPic!=''?headPic:require('../../../assets/default_avatar.png')"/>
							<span>点击修改头像</span>
						</div>
					</el-upload>
				</div>
				<form style="margin-top: -10px">
					<div class="formlist">
						<span class="form-item"><i>*</i>昵称</span>
						<input v-model="nickName" class="inputtext" placeholder="未设置"/>
					</div>
					<div class="formlist">
						<span class="form-item">性别</span>
						<!-- <input v-model="sex" class="inputtext" placeholder="未设置"/> -->
						<div class="radio-sex">
							<el-radio v-model="sex" label="男">男</el-radio>
							<el-radio v-model="sex" label="女">女</el-radio>
						</div>
					</div>
					<div class="formlist">
						<span class="form-item"><i>*</i>姓名</span>
						<input v-model="realName" class="inputtext" placeholder="未设置"/>
					</div>
					<div class="formlist">
						<span class="form-item">生日</span>
						<el-date-picker
						v-model="birthday"
						type="date"
						value-format="yyyy-MM-dd"
						placeholder="选择日期">
						</el-date-picker>
					</div>
					<div class="formlist">
						<span class="form-item">身份证</span>
						<input v-model="idCard" class="inputtext" placeholder="未设置"/>
					</div>
					<div class="formlist">
						<span class="form-item"><i>*</i>邀请部门</span>
						<el-select v-model="departmentId" placeholder="请选择" @change="departChange">
							<el-option
							v-for="item in departList"
							:key="item.id"
							:label="item.departmentName"
							:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="formlist">
						<span class="form-item">邀请人</span>
						<input v-model="invitationUserName" class="inputtext" placeholder="未设置"/>
					</div>
					<div class="formlist">
						<span class="form-item">所在区域</span>
						<el-cascader
						clearable
						placeholder="请选择"
						v-model="value"
						:props="cascaderProps"
						ref = "cs"
						@change="areaHandleChange"
						></el-cascader>
						<!-- <el-cascader
						v-model="value"
						:options="options"
						@change="handleChange"
						@expand-change = "ab"
						>
						</el-cascader> -->
					</div>
					<div class="formlist">
						<span class="form-item"><i>*</i>单位地址</span>
						<input v-model="addressDetail" class="inputtext" placeholder="未设置"/>
					</div>
					<div class="formlist formlist-company">
						<span class="form-item"><i>*</i>单位名称</span>
						<input :value="companyName" class="inputtext" @input="listenCompany" placeholder="未设置"/>
						<ul class="company-search" v-if="isShowCompanyList">
							<li @click="changeCompany(item)" v-for="(item) in companyList" :key="item.id">{{item.companyName}}</li>
						</ul>
					</div>
					<span style="margin-top:20px; margin-bottom:0" class="btns-single" @click="saveUserInfo">保存</span>
				</form>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { post,config,ajaxParam } from '../../../units/request.js'
import ContentNo from '../../../components/contentno'
export default {
  name: '',
  components: {
    ContentNo
  },
  data(){
	return{
		userId: '',
    uuid:'',
		userInfo: {}, //用户基本信息
		integralInfo: {}, //积分信息
		activityId: '',
		integralDialog: false,
		prizelDialog: false,
		userDialog: false,
		pageNum: 1,
		pageSize: 10,
		dataList: [],
		headPic: '../../../../assets/default_avatar.png',
		nickName: '',
		sex: '',
		realName: '',
		birthday: '',
		total: 0,
		addressDetail: '',
		address: '',
		provinceId: '',
		provinceName: '',
		cityId: '',
		cityName: '',
		districtId: '',
		districtName: '',
		companyName: '',
		idCard: '',
		value: [],
		options: [],
		cityList: [],
		cascaderProps: {
			lazy: true,
			lazyLoad: this.lazyLoad
        },
		parentId: 1000,
		uploadUrl: '',
		companyList: [],
		isShowCompanyList: false,
		departList: [], //部门列表
		departmentId: '', //部门id
		invitationUserName: '', //邀请人
		activityType: 1
	}
  },
  methods: {
	showIntegralDialog() {
		this.getDataList('v1/integral/getUserIntegralBalance')
		this.integralDialog = true
	},
	showPrizeDialog(){

		this.getDataList('v1/integral/getUserPrizeRecord')
		this.prizelDialog = true
	},
	showuserDialog(){
		this.userDialog = true
		this.getDepartList()
	},
	closeUserDialog(){
		this.userDialog = false
	},
	closePrizeDialog(){
		this.prizelDialog = false
		this.pageNum = 1
		this.dataList = []
		this.total = 0
		this.getDataList('v1/integral/getUserIntegralBalance')
	},
	closeIntegralDialog(){
		this.integralDialog = false
		this.pageNum = 1
		this.dataList = []
		this.total = 0
		this.getDataList('v1/integral/getUserIntegralBalance')
	},
	//获取用户信息
	async getUserInfo(){
		let url = 'v1/user/getUserDetail'
		let param = {
			userId: this.uuid,
      token:localStorage.getItem('token'),
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.userInfo = res.data.entity
			this.headPic = this.userInfo.headPic
			this.nickName = this.userInfo.nickName
			this.sex = this.userInfo.sex
			this.realName = this.userInfo.realName
			this.birthday = this.userInfo.birthdayStr
			this.addressDetail = this.userInfo.address
			this.companyName = this.userInfo.companyName
			this.value = [this.userInfo.provinceId, this.userInfo.cityId, this.userInfo.districtId]
			this.idCard = this.userInfo.idCard
			this.uuid = this.userInfo.uuid
			this.departmentId = this.userInfo.departmentId
			this.invitationUserName = this.userInfo.invitationUserName
			//从登录进来，资料没有完善的先弹窗
			if(!this.companyName&&this.fromPage=='/login') {
				this.showuserDialog()
			}
			// setTimeout(() => {
			// 	this.$refs["cs"].inputValue = this.userInfo.provinceName + " / " + this.userInfo.cityName + " / " + this.userInfo.districtName;
			// }, 1000);
		} else {
      //返回登录
      this.$router.push('/login')
			// this.$message.error(res.data.msg)
		}
	},
	//获取用户积分信息
	async getUserIntegral(){
		let url = 'v1/integral/getUserIntegral'
		let param = {
			userId: this.userId,
			activityId: this.activityId,
      token:localStorage.getItem('token'),
    }
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.integralInfo = res.data.entity
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//获取获奖信息列表
	async getDataList(url){
		let param = {
			userId: this.userId,
			activityId: this.activityId,
			pageNum: this.pageNum,
			pageSize: this.pageSize
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.dataList = res.data.list
			this.total = res.data.total
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//获取部门列表
	async getDepartList(){
		let url = 'v1/user/getDepartmentList'
		let param = {}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.departList = res.data.list
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//所选部门发生变化
	departChange(e){
		this.departmentId = e
	},
	//保存用户信息
	async saveUserInfo(){
		let nickName = this.nickName
		let realName = this.realName
		//let birthday = this.birthday
		let companyName = this.companyName
		//let address = this.value
		let addressDetail = this.addressDetail
		let idCard = this.idCard
		let departmentId = this.departmentId
		if(this.headPic.length<=0){
			this.$message.error('请上传头像！')
			return
		}
		if(nickName.length<=0){
			this.$message.error('昵称不能为空！')
			return
		}
		if(realName.length<=0){
			this.$message.error('姓名不能为空！')
			return
		}
		// if(birthday.length<=0){
		// 	this.$message.error('生日不能为空！')
		// 	return
		// }
		if(idCard) {
			const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			if (!regIdCard.test(idCard)) {
				this.$message.error('身份证号码有误！')
				return false
			}
		}
		if(departmentId=='') {
			this.$message.error('请选择邀请部门！')
			return
		}
		// if(address.length<=0){
		// 	this.$message.error('请您选择您所在的地区！')
		// 	return
		// }
		if(addressDetail.length<=0){
			this.$message.error('单位地址不能为空')
			return
		}
		if(companyName.length<=0){
			this.$message.error('单位名称不能为空！')
			return
		}
		let url = 'v1/user/updateUser'
		let param = {
      token:localStorage.getItem('token'),
			userId: this.userId,
			headPic: this.headPic,
			nickName: this.nickName,
			sex: this.sex,
			realName: this.realName,
			birthday: this.birthday,
			provinceId: this.value[0],
			provinceName: this.provinceName,
			cityId: this.value[1],
			cityName: this.cityName,
			districtId: this.value[2],
			districtName: this.districtName,
			address: this.addressDetail,
			companyName: this.companyName,
			idCard: this.idCard,
			departmentId: this.departmentId,
			invitationUserName: this.invitationUserName
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.$message.success('修改个人信息成功！')
			this.$emit('userInfoChange')
			setTimeout(()=>{
				this.closeUserDialog()
				this.getUserInfo()
			},3000)
		} else {
			this.$message.error(res.data.msg)
		}
	},
	handleCurrentChange(e){
		this.dataList = []
		this.pageNum = e
		this.getDataList('v1/integral/getUserPrizeRecord')
	},
	handleAvatarSuccess(res){
		this.headPic = res.entity.fileUrl
	},
	lazyLoad(node, resolve) {
      this.getCityData(node, resolve);
    },
	getCityData(node, resolve){
		if (!node) {
           return false
       }
      const { level } = node
      //level代表当前点击选择哪一项，，比如0代表第一次进去加载数据，1是选择省后的操作
      if (level == 1) {
        this.parentId = node.value   //选择省后对数据进行存储，因为要用省去查询市
      } else if (level == 2) {
        this.parentId = node.value    //同上要去查询区
      }
	let url = 'v1/region/selectCity'
	let param = {
		parentId: this.parentId
	}
	ajaxParam(param)
	const res =  post(url, qs.stringify(param))
      res.then((res) => {   //换成你的接口方法
        //if (res.msg.code == 200) {
          resolve(
			res.data.list.map(item=>({
				value: item.id,
				label: item.keyName,
				parentId: item.parentId,
				leaf: level >= 2
			}))
          )
        //}
      })
	},
	//获取城市数据
	async getCityList(){
		let url = 'v1/region/selectCity'
		let param = {
			parentId: 1000
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			let result = res.data.list.map(item=>({
				value: item.id,
				label: item.keyName,
				parentId: item.parentId
			}))
			this.options = result
		} else {
			this.$message.error(res.data.msg)
		}
	},
	//获取级联菜单选择数据
	areaHandleChange(e){
		console.log(e)
		setTimeout(()=>{
			let selectValue = this.$refs.cs.inputValue.split('/')
			this.provinceName = selectValue[0]
			this.cityName = selectValue[1]
			this.districtName = selectValue[2]
		},300)
	},
	async handleChange(value){
		this.provinceId = value[0]
		let url = 'v1/region/selectCity'
		let param = {
			parentId: this.provinceId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		let result = res.data.list.map(item=>({
				value: item.id,
				label: item.keyName,
				parentId: item.parentId
		}))
		let p = this.options
		p.forEach(item=>{
			if(item.value==this.provinceId) {
				item.children = result
			}
		})
		this.options = p
	},
	listenCompany(e){
		this.companyName = e.target.value
		this.getUserCompanyName()
	},
	//获取单位名称模糊查询数据
	async getUserCompanyName(){
		let url = 'v1/user/getUserCompanyName'
		let param = {
			companyName: this.companyName
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200){
			this.companyList = res.data.list
			if(res.data.list.length>0) {
				this.isShowCompanyList = true
			} else {
				this.isShowCompanyList = false
			}
		}
	},
	changeCompany(item){
		this.companyName = item.companyName
		this.isShowCompanyList = false
	},
	clearCompany(){
		this.isShowCompanyList = false
	}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm相当于上面的this
    vm.fromPage = from.path
    });
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.uuid = localStorage.getItem('uuid')
	this.activityId = localStorage.getItem('activityId')
	if(localStorage.getItem('activityType')){
		this.activityType = localStorage.getItem('activityType')
	}
	this.uploadUrl = config.baseUrl + 'v1/upload/res'
	this.getUserInfo()
	this.getUserIntegral()
	this.getDataList('v1/integral/getUserIntegralBalance')
	this.getCityList()
  }
}
</script>

<style scoped>
.userinfo-cnt{
	float: right;
	width: 88%;
	min-height: 300px;
	box-sizing: border-box;
}
.userinfo-cnt h3{line-height: 74px; font-size: 20px; font-weight: bold;}
.userinfo-avatar{float:left}
.userinfo-avatar img{float: left; width: 83px; height: 83px; margin-right: 35px; border-radius: 50%;}
.userinfo-avatar-r{float: left;}
.userinfo-cnt .userinfo-avatar{width:100%}
.prize-info li{float:left; width: 20%; height:72px; padding:0 3%; box-sizing: border-box; border-right:1px solid #E5E5E5; text-align: center;}
.prize-info li:last-of-type{border-right:none}
.prize-item{font-size:14px; line-height: 27px;}
.prize-num{padding-top: 15px; font-size: 25px; font-weight: bold;}
.prize-info li:nth-of-type(1) .prize-num,.prize-info li:nth-of-type(2) .prize-num{color:#DE0515}
.baseinfo-title{padding:20px 0 0;}
.baseinfo-title h3{float: left;}
.baseinfo-more{float: right; margin-top:25px; color:#0EA5F3}
.userinfo-cnt .userinfo-avatar .baseinfo-more{margin-top:0}

/*编辑信息弹窗 */
.user-dialog{width:440px; margin:-40px auto 0}
.dialog-avatar{width:100px; margin:0 auto; text-align: center;}
.dialog-avatar h6{padding-bottom: 10px; font-size: 16px;}
.avatar-cnt{padding-bottom: 10px;}
.avatar-cnt img{width: 72px; height: 72px; margin-top:10px; border-radius: 50%;}
.avatar-cnt span{display: block; margin-top: 0px}
.formlist{height: 30px; margin-top: 10px; line-height: 30px; clear:both; position: relative}
.form-item{float: left; width:90px; margin-right: 20px; text-align: right;}
.form-item i{padding-right: 5px;color: red;}
.formlist .inputtext,.radio-sex{width: 290px; height:30px; padding:0 20px; background:#f7f7f7; border-radius:6px; color:#606060}
.radio-sex{float:left;}
.formlist .el-radio{font-size: 26px!important; margin-top: -5px}
.formlist .el-radio__label, .el-checkbox__label {font-size: 14px!important;}
.hidden-input{display: none;}
.formlist .el-input__inner{height: 32px}

.prize-icon{width: 13px; height: 17x}
.prize-icon2{width: 18px}
.formlist-company{position: relative;}
.company-search{position: absolute; left:80px; right:20px; bottom:32px; background:#fff; border:1px solid #DCDFE6; border-radius: 6px;}
.company-search li{padding-left: 20px; border-bottom:1px solid #DCDFE6;}
.company-search li:last-of-type{border-bottom:none;}

.integral-table{margin-top: -20px}

.userinfo-cnt .contentno{margin-top: 60px}
.userinfo-cnt .contentno img{width: 70px; height: 52px; margin-bottom: 20px;}
.userinfo-cnt .contentno .content-span{font-size: 14px;}
.el-dialog__body .contentno{margin-top: 40px}
.el-dialog__body .contentno img{width: 56px; height: 45px; margin-bottom: 10px;}
.el-dialog__body .contentno .content-span{font-size: 14px;}
.el-input__icon,.el-cascader{line-height: 30px;}

.baseinfo-list-wrap{display: flex; justify-content: space-between;}
.baseinfo-list{flex:1; height: 112px; margin: 0 10px; background: #F7F7F7; display: flex; flex-direction: column; justify-content: center; align-items: center;}
.baseinfo-item{font-size: 13px;}
.baseinfo-num{padding-top: 10px; font-size: 16px; color:#4a4a4a; display: flex; align-items: center;}
.baseinfo-num span{padding-right: 5px; font-size: 25px; color: #DE0515;}
</style>
